
class RelatedContent {
    constructor() {

    }

        moveRelatedItemsToTheBody() {
            window.ListsContent.styleLists();
            const container = document.getElementById('related-body-content');
            const related = document.getElementById('content-body-related-items');
            if(!related)return;

            if(container !== undefined && container !== null) {
                while (related.childNodes.length > 0) {
                    container.appendChild(related.childNodes[0]);
                }
            } else{
                    related.classList.remove('do-not-show');
            }
        }
    }

export default RelatedContent;
